import { apiClient } from "@base/api/client";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

/**
 * 검색 필터 선택지. 프로젝트 전체 목록을 한 번 받아 로컬에서 이름을 좁힌다.
 * 기존 API의 `keyword` 이름 검색은 쓰지 않는다 (api-contract §6).
 */

const filterOptionSchema = z.object({
  id: z.number(),
  name: z.string(),
});

const filterOptionsResponseSchema = z.object({
  results: z.array(filterOptionSchema),
});

export type FilterOption = z.infer<typeof filterOptionSchema>;

type FilterOptionKind = "contractors" | "tags";

async function fetchFilterOptions(projectId: number, kind: FilterOptionKind): Promise<FilterOption[]> {
  const response = await apiClient.get<unknown>(`/project-management/api/projects/${projectId}/${kind}`);
  return filterOptionsResponseSchema.parse(response.data).results;
}

export function filterOptionsQueryOptions(projectId: number, kind: FilterOptionKind) {
  return {
    queryKey: ["daily-log-search-filter-options", kind, projectId] as const,
    queryFn: () => fetchFilterOptions(projectId, kind),
  };
}

export function useFilterOptionsQuery(projectId: number, kind: FilterOptionKind) {
  return useQuery(filterOptionsQueryOptions(projectId, kind));
}
